<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <div class="card-smallHeader card-header-action" v-b-toggle.collapse-avis-impot>
        <div class="card-header-actions">
          <span class="when-opened">
            <i class="icon-arrow-down"></i>
          </span>
          <span class="when-closed">
            <i class="icon-arrow-up"></i>
          </span>
        </div>
        <h5 class="d-inline-block">{{ titre }}</h5>
      </div>
      <b-collapse id="collapse-avis-impot" v-model="isOpened" class="m-3" :class="isOpened ? 'not-collapsed' : 'collapsed'">
        <b-card-body> 
          <div v-for="(data,key) in dataAvisImpot">
            <b-row class="my-1">
              <b-col sm="4">
                <label >Année des revenus :</label>
              </b-col>
              <b-col sm="8">
                <b-form-input :name="'annee-'+key" v-model="data.annee" class="d-inline-block" style="width: 40%" type="number"></b-form-input>
                <b-form-checkbox class="ml-3" :id="'checkbox-not-available-'+key" v-model="data.is_not_available" :name="'checkbox-not-available-'+key" value="true"></b-form-checkbox>
                <i class="fa fa-question-circle text-danger" v-b-tooltip.hover.top title="Information non présente ou illisible"></i>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="4">
                <label >Revenu fiscal :</label>
              </b-col>
              <b-col sm="8">
                <b-form-input :name="'revenu_fiscal-'+key" v-model="data.revenu_fiscal" class="d-inline-block" style="width: 40%" type="number"></b-form-input>
                <b-form-checkbox class="ml-3" :id="'checkbox-not-available-revenu-fiscal-'+key" v-model="data.is_not_available_revenu_fiscal" :name="'checkbox-not-available-revenu-fiscal-'+key" value="true"></b-form-checkbox>
                <i class="fa fa-question-circle text-danger" v-b-tooltip.hover.top title="Information non présente ou illisible"></i>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="4">
                <label >Nombre de parts :</label>
              </b-col>
              <b-col sm="8">
                <b-form-input :name="'nb_parts-'+key" v-model="data.nombre_parts" class="d-inline-block" style="width: 40%" type="number"></b-form-input>
                <b-form-checkbox class="ml-3" :id="'checkbox-not-available-nombre-part-'+key" v-model="data.is_not_available_nombre_parts" :name="'checkbox-not-available-nombre-part-'+key" value="true"></b-form-checkbox>
                <i class="fa fa-question-circle text-danger" v-b-tooltip.hover.top title="Information non présente ou illisible"></i>
              </b-col>
              <i class="fa fa-plus clickable text-success " @click="addAvis()"></i>
            </b-row>
          </div>
        </b-card-body>
      </b-collapse>
      <slot></slot>
    </b-card>
  </div>
</template>

<script>
  import {isEmpty} from "@/utils/fileHelper";

  export default {
    name: "FormPeriodeAvisImpot",
    props: ['dataAvisImpot', 'titre', 'typePeriode'],
    data() {
      return {
        isEmpty,
        isOpened: true,
      }
    },
    watcher: {
    },
    mounted() {
      this.$event.on('toggleCollapse', (value, typesId) => {
        // console.log('value, typesId',value, typesId)
        const intersection = this.typePeriode.filter(el => typesId.includes(el));
        if (intersection.length > 0) {
          this.isOpened = value === 'close' ? false : true;
        }
      });
    },
    created() {
    },
    methods: {
      addAvis() {
        this.dataAvisImpot.push({id: null, annee: null, revenu_fiscal: null, nombre_parts: null, is_not_available: null, is_not_available_revenu_fiscal: null, is_not_available_nombre_parts: null});
      },
    }
  }
</script>
